<template>
  <div class="flex gap-3">
    <div class="flex-1">
      <input 
        :value="displayName" 
        type="text" 
        class="w-full h-11 px-3 py-2 bg-slate-50 border border-slate-300 rounded-md text-slate-500"
        placeholder="Powiąż produkt" 
        disabled
      />
    </div>
    <button 
      class="h-11 px-6 border border-slate-300 text-slate-700 bg-white rounded-md hover:border-blue-500 hover:text-blue-600 transition-colors font-medium" 
      type="button" 
      @click="openModal"
    >
      Powiąż produkt
    </button>
    <button 
      v-if="productId" 
      class="h-11 px-4 border border-red-300 text-red-600 bg-white rounded-md hover:border-red-500 hover:bg-red-50 transition-colors" 
      type="button" 
      @click="clearSelection" 
      title="Usuń powiązanie"
    >
      <font-awesome-icon icon="times" />
    </button>
  </div>
  
  <ProductPickerModal 
    :show="showModal" 
    @close="closeModal" 
    @select="handleSelect" 
  />
</template>

<script setup lang="ts">
import { ref } from 'vue';
import ProductPickerModal from './ProductPickerModal.vue';

interface Product {
  id: number;
  name: string;
  description?: string | null;
}

const props = defineProps<{
  productId: number | null;
  displayName: string;
}>();

const emit = defineEmits<{
  select: [product: Product];
  clear: [];
}>();

const showModal = ref(false);

function openModal() {
  showModal.value = true;
}

function closeModal() {
  showModal.value = false;
}

function handleSelect(product: Product) {
  emit('select', product);
  closeModal();
}

function clearSelection() {
  emit('clear');
}
</script>